{
  "details": "Chi tiết",
  "image": "Hình ảnh hoạt động",
  "startDate": "Ngày bắt đầu: {{date}}",
  "endDate": "Ngày kết thúc: {{date}}",
  "rewardTarget": "Đối tượng nhận thưởng: cấp VIP {{levels}}",
  "status": {
    "ongoing": "Đang diễn ra",
    "ended": "Đã kết thúc",
    "has-not-started": "Chưa bắt đầu"
  }
}
